import router from './router'
import store from './store'
import { autoinitModules } from './store'
import { Notification } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getUserSessionId } from '@/utils/auth' // get token from cookie
import getField from '@/utils/getField'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/password-recovery'] // no redirect whitelist

// prevent unauthorized access (here because whe need store by direct using)
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // TODO: set page title
  // document.title = getPageTitle(to.meta.title)

  let isPagesInitialized = store.state.app.pages.length !== 0
  // console.log('to.path: %o; userLoggedIn: %o, isPagesInitialized: %o', to.path, store.state.app.userLoggedIn, isPagesInitialized)

  // determine whether the user has logged in
  const hasSession = getUserSessionId()

  if (hasSession) {
    if (to.path !== '/login' && store.state.app.userLoggedIn === null) {
      console.warn('USER NOT LOGGED IN')
      next('/login')
      NProgress.done()
    } else if (!isPagesInitialized) {
      try {
        const user = await store.dispatch('user/getInfo')
        const { roles, permissions } = user

        const accessRoutes = await store.dispatch('buildPages', { roles, permissions })

        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // autoload modules - dispatch initialization action
        await autoinitModules()
        await store.dispatch('initialization')

        // hack method to ensure that addRoutes is complete
        // set the replace: true, so the navigation will not leave a history record
        next({ ...to, replace: true })
      } catch (error) {
        // remove token and go to login page to re-login
        await store.dispatch('user/resetSession')

        // Message.error(error || 'Has Error')
        console.error('ERROR on retrieve userInfo: %o', error || 'Has Error')
        let errorMessage = getField(error, 'response.data.body.message') || getField(error, 'response.data.message') || error.message || 'Error'
        let errorException = getField(error, 'response.data.body.exception') || getField(error, 'response.data.exception') || error.message || 'Error'

        Notification({
          title: errorMessage,
          message: errorException,
          type: 'error',
          position: 'top-right',
          duration: 4000
        })

        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    } else {
      next()
    }
  } else {
    /* has no token */

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js